import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import SingleSpeakerV2 from "./SingleSpeakerV2";
import back from "./6.jpeg";

const normalize = (s = "") => s.toString().trim().toLowerCase();

const ALIASES = {
  uae: "united arab emirates",
  "u.a.e": "united arab emirates",
  usa: "united states",
  us: "united states",
  uk: "united kingdom",
};

const resolveCountryKey = (countryName = "") => {
  const key = normalize(countryName);
  return ALIASES[key] || key;
};

const SpeakerV2 = ({ conferenceId }) => {
  const [speakers, setSpeakers] = useState([]);
  const [countryFlagMap, setCountryFlagMap] = useState({}); // { "united arab emirates": "https://..." }

  const BaseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [spRes, cRes] = await Promise.all([
          axios.get(`${BaseUrl}/speakers/all/${conferenceId}`),
          axios.get("https://eventscons.com/eventbackendnew/api/countries"),
        ]);

        const spList = Array.isArray(spRes.data) ? spRes.data : spRes.data?.data || [];
        setSpeakers(spList);

        const cList = Array.isArray(cRes.data) ? cRes.data : cRes.data?.data || [];
        const map = {};

        cList.forEach((c) => {
          const name = c?.name || c?.country_name || c?.country || c?.title;
          const flag = c?.flag_url || c?.flag || c?.flagUrl;
          if (name && flag) map[normalize(name)] = flag;
        });

        setCountryFlagMap(map);
      } catch (error) {
        console.error("Error fetching speakers/countries:", error);
      }
    };

    fetchAll();
  }, [BaseUrl, conferenceId]);

  const groupedSpeakers = useMemo(() => {
    const sorted = [...speakers].sort((a, b) => {
      const an = normalize(a?.name || a?.full_name || a?.speaker_name || "");
      const bn = normalize(b?.name || b?.full_name || b?.speaker_name || "");
      return an.localeCompare(bn);
    });

    const groups = {};
    sorted.forEach((sp) => {
      const name = (sp?.name || sp?.full_name || sp?.speaker_name || "").toString().trim();
      const first = (name[0] || "#").toUpperCase();
      const key = /^[A-Z]$/.test(first) ? first : "#";
      (groups[key] ||= []).push(sp);
    });

    const ordered = {};
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").forEach((k) => groups[k]?.length && (ordered[k] = groups[k]));
    groups["#"]?.length && (ordered["#"] = groups["#"]);
    return ordered;
  }, [speakers]);

  return (
    <section className="speakersV2" style={{ backgroundImage: `url(${back})` }}>
      <div className="auto-container">
        <div className="sec-title light text-center">
          <h2 className="speakersV2__title" style={{marginTop:'20px'}}>Speakers</h2>
        </div>

        {Object.keys(groupedSpeakers).map((letter) => (
          <div className="speakersV2__group" key={letter}>
            <div className="speakersV2__letter">{letter}</div>

            <div className="speakersV2__grid">
              {groupedSpeakers[letter].map((speaker) => {
                const countryName = (speaker?.country_of_residence || "").toString().trim();
                const key = resolveCountryKey(countryName);
                const flagUrl = countryFlagMap[key];

                return (
                  <SingleSpeakerV2
                    key={speaker.id}
                    speaker={speaker}
                    countryName={countryName}
                    flagUrl={flagUrl}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SpeakerV2;
